import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AppProvider } from '@/context/AppContext';
import { AuthProvider } from '@/context/AuthContext';
import { WorkspaceProvider } from '@/context/WorkspaceContext';
import { router } from '@/router';
import { ApiError } from '@/api/client';
import { Toaster } from '@/components/ui/sonner';
import { ConfirmDialogProvider } from '@/components/ui/confirm-dialog';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.isAuthError) return false;
          if (error.status && error.status < 500) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <ConfirmDialogProvider>
          <AuthProvider>
            <WorkspaceProvider>
              <RouterProvider router={router} />
              <Toaster richColors position="top-right" />
            </WorkspaceProvider>
          </AuthProvider>
        </ConfirmDialogProvider>
      </AppProvider>
    </QueryClientProvider>
  );
}
